var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isCopyComplete)?_c('TableComponent',{ref:"tableData",attrs:{"items":_vm.localItemsArray,"columns":_vm.columns},on:{"nextModal":_vm.nextModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }